import { TabContext } from "@mui/lab";
import { Container, Stack, Typography } from "@mui/material";
import makeStyles from "@mui/styles/makeStyles";
import { useEffect, useState } from "react";
import UnassignedContentsBadge from "../atoms/UnassignedContentsBadge";
import GeneralSettings from "../modals/home/GeneralSettings";
import PlanModal from "../modals/subscriptions/PlanModal";
import configuredAsyncComponentLoader from "../templates/loader";

const ActivityFeed = configuredAsyncComponentLoader(() => import('../organisms/home/ActivityFeed'));

export enum HomePageTabs {
    Pipeline = 'Pipeline',
    Shared = 'Shared with you',
}

const useStyles = makeStyles((theme) => ({
    rootContainer: {
        height: '100%',
        maxWidth: 'unset !important',
        overflow: 'hidden',
        padding: 'unset',
    },
    title: {
        fontFamily: 'Poppins',
        fontSize: '2.2rem',
        fontWeight: '700',
    },
    tabs: {
        "& .MuiTabs-indicator": {
            height: 3,
            background: theme.colors.primary['700'],
        }
    },
    tab: {
        minWidth: 100,
        minHeight: 48,
        marginRight: 8,
        padding: '6px 8px',
    },
    tabText: {
        color: '#878E95',
        fontFamily: 'Lato',
        fontWeight: 'bold',
        textTransform: 'none',
    },
    selectedTabText: {
        color: 'black',
        fontFamily: 'Lato',
        fontWeight: 'bold',
    },
    tabPanel: {
        height: '100%',
        width: '100%',
        padding: 'unset',
    },
    mainText: {
        fontFamily: 'Inter',
        fontSize: '1.1rem',
        fontWeight: 'bold',
        color: theme.colors.success['500'],
    },
    subText: {
        fontFamily: 'Lato',
        fontSize: '1rem',
        fontWeight: 500,
        color: '#666666',
    },
}));



const HomePage: React.FC<{}> = () => {
    const classes = useStyles();
    const [selectedTab] = useState<HomePageTabs>(HomePageTabs.Pipeline);
    const [, setInstance] = useState<boolean>(true);

    useEffect(() => {
        if (selectedTab === HomePageTabs.Shared)
            setInstance(false);
    }, [selectedTab]);

    return (<>
        <Container className={classes.rootContainer}>
            <TabContext value={selectedTab}>
                <Stack direction="row" alignItems="center" justifyContent="space-between" pt={2}>
                    <Stack direction="row" spacing={2} alignItems="center" justifyContent="flex-start" ml={3}>
                        <Stack alignItems="center" justifyContent="center" p={2} width={50} height={50}
                            sx={{ borderRadius: 4, background: 'linear-gradient(90deg, #17b7a5 0%, #0e9486 100%)' }}>
                            <Typography fontSize="1.4rem !important" fontWeight="bold" fontFamily="Inter" color="#fff">
                                {'N'}
                            </Typography>
                        </Stack>
                        <Stack direction="column" alignItems="flex-start" justifyContent="flex-start" >
                            <Typography fontFamily="Inter" fontWeight="bold" fontSize="1.5rem !important">
                                {'Your Pipeline'}
                            </Typography>
                            <Typography fontSize="0.9rem" fontWeight="400" color="#64748b">
                                {'Manage your deals and opportunities'}
                            </Typography>
                        </Stack>
                    </Stack>
                    <Stack direction="row" alignItems="center" justifyContent="flex-end" mr={2}>
                        <UnassignedContentsBadge />
                        <GeneralSettings />
                    </Stack>
                </Stack>
                <ActivityFeed />
            </TabContext>
        </Container>
        <PlanModal variant="limit" />
    </>);
}

export default HomePage;
